import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('DueAtDeliveryWrapper')(({ isCompareSection }) => css({
    display: 'flex',
    flexDirection: isCompareSection ? ['column', 'column', 'row'] : 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 'm',
    mt: 'xs',
}));
themeStyles.addBaseStyles('PriceCopy')(() => css({
    fontFamily: 'bold',
}));
export default themeStyles;
